import { useEffect, useRef, useState } from 'react';
import Header from './Header';
import { useDrop } from "react-dnd";
import { motion } from "framer-motion";
import DragLatter from './DragLatter';
import AlphabetLater from "./Alphabet";
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import triangle from '../home/images/white-triangle.svg'
import quiticon from "../assets/quit.svg"
import removeletter from "../assets/remove-letter.svg"
import { GameHistoryModal } from './Header';
import { ScoreChart } from './Header';
import { useNavigate } from 'react-router-dom';
import './home.css';

// image number start here 
import img0 from '../assets/number/0.png';
import img1 from '../assets/number/1.png';
import img2 from '../assets/number/2.png';
import img3 from '../assets/number/3.png';
import img4 from '../assets/number/4.png';
import img5 from '../assets/number/5.png';
import img6 from '../assets/number/6.png';
import img7 from '../assets/number/7.png';
import img8 from '../assets/number/8.png';
import img9 from '../assets/number/9.png';
import slashimg from '../assets/slash.png';
// image number start here 


const LetterText = () => {

    const [strike, setStrike] = useState(0);
    const [alphabets, setAlphabets] = useState([]);
    const [firstContainer, setFirstContainer] = useState(null);
    const [secondContainer, setSecondContainer] = useState(null);
    const [thirdContainer, setThirdContainer] = useState(null);
    const [fourthContainer, setFourthContainer] = useState(null);
    const [fifthContainer, setfifthContainer] = useState(null);
    const [sixcontainer, setSixcontainer] = useState(null);
    const [seventhcontainer, setSeventhcontainer] = useState(null);
    const [eightcontainer, setEightcontainer] = useState(null);
    const [ninecontainer, setNinecontainer] = useState(null);
    const [tencontainer, setTencontainer] = useState(null);
    const [tournamentId, setTournamentId] = useState(0);
    const [errormsg, setErrormsg] = useState("");

    const [reset, setReset] = useState(false);
    const [, setScore] = useState(0);
    const [newData, setNewData] = useState([]);
    const [selectedItms, setSelectedItms] = useState([]);
    const [scoremodal, setScormodal] = useState(false);
    const [historyModal, setHistoryModal] = useState(false);
    const [selectedVal, setSelectedVal] = useState([]);
    const [round, setRound] = useState(1);
    const [gameId, setGameId] = useState('');
    const gameCurrentId = useRef()
    const [show, setShow] = useState({
        firstshow: false,
        secondshow: false,
        thirdshow: false,
        errormsg: false
    });

    const [quit, setQuit] = useState(false);
    const [invalidmsg, setInvalidmsg] = useState(0);
    const [newround, setNewround] = useState(1);
    const [isAnimating, setIsAnimating] = useState(false);
    const [localvar, setLocalvar] = useState([]);

    const [allRoundTotalScore, setAllRoundTotalScore] = useState([
        {
            "score": 0,
            "totalScore": 0
        },
        {
            "score": 0,
            "totalScore": 0
        },
        {
            "score": 0,
            "totalScore": 0
        }
    ]);

    const [allRoundInvalidCount, setAllRoundInvalidCount] = useState([0, 0, 0]);
    const [nextRound, setNextRound] = useState(0);
    const [completedRound, setCompletedRound] = useState([
        { "started": false, "IsCompleted": false, "Round": "1" },
        { "started": false, "IsCompleted": false, "Round": "2" },
        { "started": false, "IsCompleted": false, "Round": "3" }
    ]);

    const historycloseModal = () => setHistoryModal(false);
    const scoreopenmodal = () => setScormodal(true);
    const scoreclosemodal = () => setScormodal(false);
    localStorage.setItem("tournamentId", tournamentId);

    // dropbox state end here 

    const [_checkData, setCheckdata] = useState(
        [firstContainer, secondContainer, thirdContainer, fourthContainer, fifthContainer, sixcontainer, seventhcontainer, eightcontainer, ninecontainer, tencontainer]
    );

    useEffect(() => {
        setCheckdata([firstContainer, secondContainer, thirdContainer, fourthContainer, fifthContainer, sixcontainer, seventhcontainer, eightcontainer, ninecontainer, tencontainer])
    }, [firstContainer, secondContainer, thirdContainer, fourthContainer, fifthContainer, sixcontainer, seventhcontainer, eightcontainer, ninecontainer, tencontainer]);

    const [, removeFromTeamRef] = useDrop({
        accept: "team",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
    });

    // main drag area function end
    const [{ isOver: isFirstAlphabetOver }, addToFirstContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {

            let a = document.getElementsByClassName("dropbox");
            if (a[0].childNodes.length == 1) {
                //empty?
            } else {
                moveFirstAlphabetToContainer(item);
            }
        },

    });

    const [{ isOver: isSecondAlphabetOver }, addToSecondContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {
            let a = document.getElementsByClassName("dropbox");
            if (a[1].childNodes.length == 1) {
                //empty?
            } else {
                moveSecondAlphabetToContainer(item);
            }
        },
    });

    const [{ isOver: isThirdAlphabetOver }, addToThirdContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {
            let a = document.getElementsByClassName("dropbox");
            if (a[2].childNodes.length == 1) {
                //empty?
            } else {
                moveThirdAlphabetToContainer(item);
            }
        },
    });

    const [{ isOver: isFourthAlphabetOver }, addToFourthContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {
            let a = document.getElementsByClassName("dropbox");
            if (a[3].childNodes.length == 1) {
                //empty?
            } else {
                moveFourthAlphabetToContainer(item);
            }

        },
    });

    const [{ isOver: isFifthAlphabetOver }, addToFifthContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {
            let a = document.getElementsByClassName("dropbox");
            if (a[4].childNodes.length == 1) {
                //empty?
            } else {
                moveFifthAlphabetToContainer(item);
            }

        },
    });

    const [{ isOver: isSixthAlphabetOver }, addTosixthContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {
            let a = document.getElementsByClassName("dropbox");
            if (a[5].childNodes.length == 1) {
                //empty?
            } else {
                movesixthAlphabetToContainer(item);
            }
        },
    });

    const [{ isOver: isSeventhAlphabetOver }, addToseventhContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {
            let a = document.getElementsByClassName("dropbox");
            if (a[6].childNodes.length == 1) {
                //empty?
            } else {
                moveseventhAlphabetToContainer(item);
            }
        },
    });

    const [{ isOver: isEightAlphabetOver }, addToeightContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {
            let a = document.getElementsByClassName("dropbox");
            if (a[7].childNodes.length == 1) {
                //empty?
            } else {
                moveeightAlphabetToContainer(item);
            }

        },
    });


    const [{ isOver: isNineAlphabetOver }, addTonineContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {
            let a = document.getElementsByClassName("dropbox");
            if (a[8].childNodes.length == 1) {
                //empty?
            } else {
                movenineAlphabetToContainer(item);
            }

        },
    });

    const [{ isOver: isTenAlphabetOver }, addTotenContainerRef] = useDrop({
        accept: "alphabet",
        collect: (monitor) => ({ isOver: !!monitor.isOver() }),
        drop: (item) => {
            let a = document.getElementsByClassName("dropbox");
            if (a[9].childNodes.length == 1) {
                //empty?
            } else {
                movetenAlphabetToContainer(item);
            }

        },
    });


    const moveFirstAlphabetToContainer = (item) => {


        setStrickDataValue(item.index, "dropInBox", 1);
        const firstlet = [...alphabets]
        firstlet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...firstlet]);
        setFirstContainer(item);
    };

    const moveSecondAlphabetToContainer = (item) => {

        setStrickDataValue(item.index, "dropInBox", 1);
        const seclet = [...alphabets]
        seclet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...seclet]);
        setSecondContainer(item);

    };

    const moveThirdAlphabetToContainer = (item) => {

        setStrickDataValue(item.index, "dropInBox", 1);

        const thirdlet = [...alphabets]
        thirdlet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...thirdlet]);
        setThirdContainer(item);
    };

    const moveFourthAlphabetToContainer = (item) => {

        setStrickDataValue(item.index, "dropInBox", 1);
        const fourthlet = [...alphabets]
        fourthlet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...fourthlet]);
        setFourthContainer(item);
    };

    const moveFifthAlphabetToContainer = (item) => {

        setStrickDataValue(item.index, "dropInBox", 1);
        const fifthlet = [...alphabets]
        fifthlet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...fifthlet]);
        setfifthContainer(item);
    };


    const movesixthAlphabetToContainer = (item) => {

        setStrickDataValue(item.index, "dropInBox", 1);
        const sixthlet = [...alphabets]
        sixthlet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...sixthlet]);
        setSixcontainer(item);
    };

    const moveseventhAlphabetToContainer = (item) => {

        setStrickDataValue(item.index, "dropInBox", 1);
        const seventhlet = [...alphabets]
        seventhlet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...seventhlet]);
        setSeventhcontainer(item);
    };

    const moveeightAlphabetToContainer = (item) => {

        setStrickDataValue(item.index, "dropInBox", 1);
        const eightlet = [...alphabets]
        eightlet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...eightlet]);
        setEightcontainer(item);
    };

    const movenineAlphabetToContainer = (item) => {

        setStrickDataValue(item.index, "dropInBox", 1);
        const ninelet = [...alphabets]
        ninelet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...ninelet]);
        setNinecontainer(item);
    };

    const movetenAlphabetToContainer = (item) => {

        setStrickDataValue(item.index, "dropInBox", 1);
        const tenlet = [...alphabets]
        tenlet[item.index] = {
            id: item.id ? item.id : item[0].id,
            name: "",
            image: "",
            value: ""
        }
        setAlphabets([...tenlet]);
        setTencontainer(item);
    };

    // get api code start here 

    const gettoken = localStorage.getItem('token');
    //const userId = localStorage.getItem('UserId');
    localStorage.setItem('gameId', gameId);
    const gameIdset = localStorage.getItem('gameId');

    console.log("============================================");
    console.log("LETTER TEXT -- Get Token:", gettoken, "And set gameIdset:", gameIdset);
    console.log("============================================");


    const strikeCount = async () => {
        if (gameId && isAnimating == true) {
            const strikegameid = {
                "gameId": gameId,
            }
            const strikheaders = {
                Authorization: `Bearer ${gettoken}`
            }

            console.log("============================================");
            console.log("LETTER TEXT -- STRIKE COUNT");
            console.log("============================================");
            console.log("Strike GameId: ", strikegameid);
            console.log("Strike Headers: ", strikheaders);

            if (getfreepai === "free") {

                const strikeidResp = await axios.post(`${process.env.REACT_APP_API_URL}/lockitapi/Word/StrikeCountTest?gameId=${gameId}`, strikegameid,
                    { headers: strikheaders });
                console.log("Strike Response: ", strikeidResp);
                setStrike(strikeidResp?.data?.data?.strikeCount)
                setRound(strikeidResp?.data?.data?.roundNumber)

            } else {
                const strikeidResp = await axios.post(`${process.env.REACT_APP_API_URL}/lockitapi/Word/StrikeCount?gameId=${gameId}`, strikegameid,
                    { headers: strikheaders });
                setStrike(strikeidResp?.data?.data?.strikeCount)
                setRound(strikeidResp?.data?.data?.roundNumber)
            }
        }

    }

    function markRoundStart(roundNumber) {
        let roundStatusData = completedRound;

        if (roundNumber > 0 && roundNumber < 4) {
            completedRound[roundNumber - 1].started = true;
            setNextRound(roundNumber);
        }
        setCompletedRound(roundStatusData);
    }

    function clearAllTimeOut() {
        let data = localvar;
        for (let index = 0; index < data.length; index++) {
            const element = data[index];

            if (element !== undefined && element !== null && typeof (element) === 'number') {
                clearTimeout(element);
            }
        }
        setLocalvar([]);
    }

    function markRoundCompleted(roundNumber) {
        let roundStatusData = completedRound;
        setIsAnimating(false);
        clearAllTimeOut();
        setAlphabets([]);
        if (roundNumber > 0 && roundNumber < 4) {
            completedRound[roundNumber - 1].started = false;
            completedRound[roundNumber - 1].IsCompleted = true;
            setNextRound(roundNumber + 1);
        }
        setCompletedRound(roundStatusData);
    }



    function canAnimateAlphabets() {
        let roundStatusData = completedRound;

        return roundStatusData[0].started || roundStatusData[1].started || roundStatusData[2].started;

    }

    const gamefreeapi = localStorage.getItem('gametype');
    const getData = async () => {
        setIsAnimating(true);
        markRoundStart(1);
        //debugger
        if (getfreepai === "free") {
            await axios.get(`${process.env.REACT_APP_API_URL}/lockitapi/Word/GetCharListTest`, {
                headers: {
                    Authorization: `Bearer ${gettoken}`
                }
            }).then((res) => {

                console.log("============================================");
                console.log("LETTER TEXT -- getfreeapi");
                console.log("============================================");
                console.log("gamefreeapi: ", getfreepai, "from localStorage.getItem('gametype')");
                console.log("Get Data Response: ", res);
                console.log("Set gamerCurrentId.current = ", res.data.data.gameId);
                console.log("DataChar = ", res.data.data.charList.join(""));

                setGameId(res.data.data.gameId);
                gameCurrentId.current = res.data.data.gameId;
                let dataChar = res.data.data.charList.join("")
                setNewData(dataChar)

            }).catch((err) => {
                console.log('Error: ', err)
            })
        } else if (gamefreeapi === "creditpaid") {
            await axios.get(`${process.env.REACT_APP_API_URL}/lockitapi/Word/GetCharList?isPaid=true&gameId=0`, {
                headers: {
                    Authorization: `Bearer ${gettoken}`
                },
            }).then((res) => {
                if (res.data.data) {
                    setTournamentId(res.data.data.tournamentid);

                    setGameId(res.data.data.gameId);
                    let dataChar = res.data.data.charList.join("");
                    setNewData(dataChar);
                } else {
                    setErrormsg(res.data.message);
                    if (res.data.status === false) {
                        setShow({ ...show, ["errormsg"]: true });
                    }
                }

            }).catch((err) => {
                console.log('Error: ', err)
            })

        } else if (gamefreeapi === "creditfree") {
            await axios.get(`${process.env.REACT_APP_API_URL}/lockitapi/Word/GetCharList?isPaid=false&gameId=0`, {
                headers: {
                    Authorization: `Bearer ${gettoken}`
                },
            }).then((res) => {
                if (res.data.data) {
                    setTournamentId(res.data.data.tournamentid);
                    setGameId(res.data.data.gameId);
                    let dataChar = res.data.data.charList.join("");
                    setNewData(dataChar);
                } else {
                    setErrormsg(res.data.message);
                    if (res.data.status === false) {
                        setShow({ ...show, ["errormsg"]: true });
                    }
                }

            }).catch((err) => {
                console.log('Error: ', err)
            })
        }
    }

    // getnextchar api start here  
    const getNextChar = async () => {
        if (getfreepai === "free") {
            if (gameCurrentId.current) {
                await axios.get(`${process.env.REACT_APP_API_URL}/lockitapi/Word/GetCharListTest?gameId=${gameCurrentId.current}`, {
                    headers: {
                        Authorization: `Bearer ${gettoken}`
                    }
                }).then((respons) => {
                    console.log("============================================");
                    console.log("LETTER TEXT -- getNextChar");
                    console.log("============================================");
                    console.log("Headers: Bearer ", gettoken);
                    console.log("currentGameId.current: ", gameCurrentId.current);
                    console.log("Get Data Response: ", respons);
                    let nextData = respons?.data?.data?.charList?.join("");
                    setNewData(nextData);
                }).catch((reserror) => {
                    console.log('Error: ', reserror)
                })
            }

        } else {
            if (gameId) {
                await axios.get(`${process.env.REACT_APP_API_URL}/lockitapi/Word/GetCharList?gameId=${gameIdset}`, {
                    headers: {
                        Authorization: `Bearer ${gettoken}`
                    }
                }).then((respons) => {
                    let nextData = respons?.data?.data?.charList?.join("");
                    setNewData(nextData)

                }).catch((reserror) => {
                    console.log('Error: ', reserror)
                })
            }
        }
    }

    const randomSourceArray = useRef([])
    const getfreepai = localStorage.getItem('apitype');
    useEffect(() => {
        getData();
    }, [getfreepai, gamefreeapi]);

    var timer;

    useEffect(() => {
        if (newData?.length) {
            let data = newData.split('');
            if (randomSourceArray.current?.length == 0) {

                GetNextChar(data);
            }
            else {
                randomSourceArray.current.push(...data);
            }

        }

    }, [newData])


    function GetNextChar(data) {
        if (isAnimating == true) {
            clearAllTimeOut();
            let sourcedata = data.shift();
            let dataToPass = AlphabetLater.filter(alpha => alpha.name === sourcedata)[0];

            if (dataToPass) {

                addEmptyStrickData();
                setAlphabets((p) => [...p, [dataToPass]]);
                randomSourceArray.current = data;

                if (data?.length > 0 && data?.length < 3) {
                    getNextChar();
                }

            }
            else {
                clearInterval(timer);
            }
        }
    }

    // post api function start here 

    function updateAllRoundTotalScor(resp) {
        let data = allRoundTotalScore;

        for (let index = 0; index < resp.data.data.length; index++) {

            const otherIndex = resp.data.data[index].round - 1;

            if (otherIndex > -1) {

                data[otherIndex].score = resp.data.data[index].score;
                data[otherIndex].totalScore = resp.data.data[index].totalScore;
            }
        }
        setAllRoundTotalScore(data);
    }


    const allrounds = {
        firstRound: allRoundTotalScore[0].totalScore,
        secondRound: allRoundTotalScore[1].totalScore,
        thirdRound: allRoundTotalScore[2].totalScore
    }
    const currentRound = 'thirdRound';
    const roundScore = currentRound === 'firstRound' ? allrounds.firstRound : currentRound === 'secondRound' ? allrounds.secondRound : currentRound === 'thirdRound' ? allrounds.thirdRound : null;

    const getScore = async () => {
        if (getfreepai === "free") {
            await axios.get(`${process.env.REACT_APP_API_URL}/lockitapi/Word/GetScoreTest?gameId=${gameIdset}`, {
                headers: {
                    Authorization: `Bearer ${gettoken}`
                }
            }).then((resp) => {
                console.log("============================================");
                console.log("LETTER TEXT -- GET SCORE");
                console.log("============================================");
                console.log("Game Id (from gameIdset): ", gameIdset);
                console.log("Response: ", resp);
                updateAllRoundTotalScor(resp);
            })
        } else {

            await axios.get(`${process.env.REACT_APP_API_URL}/lockitapi/Word/GetScore?gameId=${gameIdset}`, {
                headers: {
                    Authorization: `Bearer ${gettoken}`
                }
            }).then((resp) => {
                updateAllRoundTotalScor(resp);
            })

        }
    }


    function markInvalidWord(res) {
        let roundInvalidData = allRoundInvalidCount;
        if (res?.data?.data?.isValid) {
            switch (res?.data?.data?.round) {
                case 1:
                    roundInvalidData[0] = roundInvalidData[0] + 1;
                    break;
                case 2:
                    roundInvalidData[1] = roundInvalidData[1] + 1;
                    break;
                case 3:
                    roundInvalidData[2] = roundInvalidData[2] + 1;
                    break;
            }
        }
        setAllRoundInvalidCount(roundInvalidData);
    }


    const handleSubmit = async () => {
        let getremovedrop = document.querySelectorAll(".dropbox");
        getremovedrop.forEach((elm) => {
            elm.classList.remove("animatebox")
        })

        let inputzero = document.querySelector(".inputbox");
        inputzero.scrollLeft = 0;

        let payload = {
            "word": `${firstContainer ? firstContainer[0]?.name : ''}${secondContainer ? secondContainer[0]?.name : ''}${thirdContainer ? thirdContainer[0]?.name : ""}${fourthContainer ? fourthContainer[0]?.name : ""}${fifthContainer ? fifthContainer[0]?.name : ""}${sixcontainer ? sixcontainer[0]?.name : ""}${seventhcontainer ? seventhcontainer[0]?.name : ""}${eightcontainer ? eightcontainer[0]?.name : ""}${ninecontainer ? ninecontainer[0]?.name : ""}${tencontainer ? tencontainer[0]?.name : ""}`,
            "gameId": gameId,
        }

        if (payload.word) {
            if (payload.word.length < 2) {
                toast.error("Create a word of atleast 2 letters.", {
                    position: "top-center",
                    theme: "colored",
                    hideProgressBar: true,
                    icon: () => <img src={triangle} />
                });

            }
            else {
                if (getfreepai === "free") {
                    const response = await axios.post(`${process.env.REACT_APP_API_URL}/lockitapi/Word/ValidateWordTest`, payload, {
                        headers: {
                            Authorization: `Bearer ${gettoken}`
                        }
                    })

                    
                    console.log("============================================");
                    console.log("LETTER TEXT -- LOCK WORD");
                    console.log("============================================");
                    console.log("Game Id (from gameId): ", gameId);
                    console.log("Headers: Bearer ", gettoken);
                    console.log("Payload: ", payload);
                    console.log("Response: ", response);


                    if (response.data.status == true) {
                        toast.success(`Awesome You got ${response.data.data.score} Point`, {
                            position: "top-center",
                            theme: "colored",
                            hideProgressBar: true,
                            icon: () => <img src={triangle} />
                        });
                        emptyAllContainer();
                        getScore();
                    } else {
                        toast.error("Invalid word.", {
                            position: "top-center",
                            theme: "colored",
                            hideProgressBar: true,
                            icon: () => <img src={triangle} />
                        });
                        setInvalidmsg(invalidmsg + 1);
                        emptyAllContainer();
                    }
                    setScore(response?.data?.data?.totalScore);
                    markInvalidWord(response);

                } else {

                    const response = await axios.post(`${process.env.REACT_APP_API_URL}/lockitapi/Word/ValidateWord`, payload, {
                        headers: {
                            Authorization: `Bearer ${gettoken}`
                        }
                    })
                    if (response.data.status == true) {
                        toast.success(`Awesome You got ${response.data.data.score} Point`, {
                            position: "top-center",
                            theme: "colored",
                            hideProgressBar: true,
                            icon: () => <img src={triangle} />
                        });
                        emptyAllContainer();
                        getScore();
                    } else {
                        toast.error("Invalid word.", {
                            position: "top-center",
                            theme: "colored",
                            hideProgressBar: true,
                            icon: () => <img src={triangle} />
                        });
                        setInvalidmsg(invalidmsg + 1);
                        emptyAllContainer();
                    }
                    setScore(response?.data?.data?.totalScore);
                    markInvalidWord(response);

                }
            }

        }
        else {
            toast.error("Please create a word.", {
                position: "top-center",
                theme: "colored",
                hideProgressBar: true,
                icon: () => <img src={triangle} />
            });
            setReset(true);
            setTimeout(() => {
                setReset(false);
            }, 2000);
        }
    }

    const onAnimationComplete = (event, index) => {
        setStrickDataValue(index, "animationComplete", 1);
    }

    const opc = { opacity: "0" };

    const containers = [
        { ref: addToFirstContainerRef, isAlphabetOver: isFirstAlphabetOver, container: firstContainer },
        { ref: addToSecondContainerRef, isAlphabetOver: isSecondAlphabetOver, container: secondContainer },
        { ref: addToThirdContainerRef, isAlphabetOver: isThirdAlphabetOver, container: thirdContainer },
        { ref: addToFourthContainerRef, isAlphabetOver: isFourthAlphabetOver, container: fourthContainer },
        { ref: addToFifthContainerRef, isAlphabetOver: isFifthAlphabetOver, container: fifthContainer },
        { ref: addTosixthContainerRef, isAlphabetOver: isSixthAlphabetOver, container: sixcontainer },
        { ref: addToseventhContainerRef, isAlphabetOver: isSeventhAlphabetOver, container: seventhcontainer },
        { ref: addToeightContainerRef, isAlphabetOver: isEightAlphabetOver, container: eightcontainer },
        { ref: addTonineContainerRef, isAlphabetOver: isNineAlphabetOver, container: ninecontainer },
        { ref: addTotenContainerRef, isAlphabetOver: isTenAlphabetOver, container: tencontainer }
    ];

    // if invalid word 3 go to next round function start here 
    useEffect(() => {
        if (invalidmsg === 3) {
            setIsAnimating(false);
            clearAllTimeOut();
            setRound(round + 1)

            if (round == 1) {
                setShow({ ...show, ["firstshow"]: true });
            } else if (round == 2) {
                setShow({ ...show, ["secondshow"]: true });
            } else if (round == 3) {
                setShow({ ...show, ["thirdshow"]: true });
            }

            setAlphabets([]);

        }
    }, [invalidmsg]);

    useEffect(() => {

        let data = allRoundInvalidCount;
        for (let index = 0; index < 3; index++) {
            if (data[index] > 2) {
                markRoundCompleted(index + 1);
            }
        }



    }, [allRoundInvalidCount]);

    function emptyAllContainer() {
        for (let index = 0; index < 10; index++) {
            setContainerData(null, index)
        }
    }


    // if invalid word 3 go to next round function start here 
    const jumptoNextround = () => {

        localStorage.setItem("strickData", []);
        emptyAllContainer();
        setInvalidmsg(0);
        let data = show;
        show.firstshow = false;
        show.secondshow = false;
        show.thirdshow = false;
        setShow(data);
        randomSourceArray.current = [];
        setNewData([]);
        setAlphabets([]);
        setSelectedItms([]);
        setIsAnimating(true);
        markRoundStart(nextRound);
        getNextChar();
        setNewround(newround + 1);
        let removeanimate = document.querySelectorAll(".dropbox");
        removeanimate.forEach((evt) => {
            evt.classList.remove("animatebox");
        });

        let inputzero = document.querySelector(".inputbox");
        inputzero.scrollLeft = 0;
    }

    let getdrop = document.querySelectorAll(".dropbox");
    getdrop.forEach((elemt) => {
        elemt.addEventListener("click", (evnt) => {
            // debugger;
            if (evnt.target.src) {
                Array.prototype.forEach.call(elemt.parentNode.children, (sibling) => {
                    if (sibling !== elemt) {
                        sibling.classList.remove("animatebox");
                    }
                });
                evnt.currentTarget.classList.add("animatebox");
            }
        });
    });

    function removeimg() {
        getdrop.forEach((elm) => {
            elm.classList.remove("animatebox")
        })
    }

    function getContainerData(index) {
        let data = null;
        switch (index) {
            case 0:
                data = firstContainer;
                break;
            case 1:
                data = secondContainer;
                break;
            case 2:
                data = thirdContainer;
                break;
            case 3:
                data = fourthContainer;
                break;
            case 4:
                data = fifthContainer;
                break;
            case 5:
                data = sixcontainer;
                break;
            case 6:
                data = seventhcontainer;
                break;
            case 7:
                data = eightcontainer;
                break;
            case 8:
                data = ninecontainer;
                break;
            case 9:
                data = tencontainer;
                break;
        }

        return data;

    }

    function setContainerData(data, index) {

        switch (index) {
            case 0:
                setFirstContainer(data);
                break;
            case 1:
                setSecondContainer(data);
                break;
            case 2:
                setThirdContainer(data);
                break;
            case 3:
                setFourthContainer(data);
                break;
            case 4:
                setfifthContainer(data);
                break;
            case 5:
                setSixcontainer(data);
                break;
            case 6:
                setSeventhcontainer(data);
                break;
            case 7:
                setEightcontainer(data);
                break;
            case 8:
                setNinecontainer(data);
                break;
            case 9:
                setTencontainer(data);
                break;
        }
    }

    function addEmptyStrickData() {
        var data = localStorage.getItem("strickData");
        let tempStrickData = JSON.parse(data || '[]');
        if (tempStrickData == "") {
            tempStrickData = [];
        }

        tempStrickData.push(
            {
                "inDragMode": false,
                "animationComplete": false,
                "dropInBox": false,
                "removedFromBox": false,
                "isStrickCounted": false
            });

        localStorage.setItem("strickData", JSON.stringify(tempStrickData));
    }

    function setStrickDataValue(index, prop, val) {
        var data = localStorage.getItem("strickData");
        let tempStrickData = JSON.parse(data || '[]');

        switch (prop) {
            case "inDragMode":
                tempStrickData[index].dragStart = val;
                break;
            case "animationComplete":
                tempStrickData[index].animationComplete = val;
                break;
            case "dropInBox":
                tempStrickData[index].dropInBox = val;
                break;
            case "removedFromBox":
                tempStrickData[index].removedFromBox = val;
                break;
            case "isStrickCounted":
                tempStrickData[index].isStrickCounted = val;
                break;
        }


        localStorage.setItem("strickData", JSON.stringify(tempStrickData));

        updateStrike();
    }


    function updateStrike() {
        var data = localStorage.getItem("strickData");
        let tempStrickData = JSON.parse(data || '[]');
        if (tempStrickData.length > 0) {
            for (let index = 0; index < tempStrickData.length; index++) {
                if (!tempStrickData[index].isStrickCounted && tempStrickData[index].animationComplete && !tempStrickData[index].inDragMode && !tempStrickData[index].dropInBox) {
                    strikeCount();
                    setStrickDataValue(index, "isStrickCounted", 1);
                } else if (!tempStrickData[index].isStrickCounted && tempStrickData[index].removedFromBox) {
                    strikeCount();
                    setStrickDataValue(index, "isStrickCounted", 1);
                }
            }

        }
    }

    const shufflevalue = (e, ind) => {
        e.target.setAttribute('draggable', false);
        if (selectedVal?.length > 0) {
            let TempData = getContainerData(ind);
            setContainerData(getContainerData(selectedVal[0]), ind);
            setContainerData(TempData, selectedVal[0]);
            setSelectedVal([]);
            removeimg();
        }
        else if (getContainerData(ind)) {
            setSelectedVal([...selectedVal, ind]);
        }
    }


    const navigate = useNavigate();
    const backtoHome = () => {
        navigate('/splash', { replace: true });
    }

    const handleRemove = (event, index, c) => {

        setStrickDataValue(c.index, "removedFromBox", 1);
        let removeletter = document.getElementsByClassName("remove-letter");
        let blankdiv = `<div></div>`

        setContainerData(null, index);
        removeletter[index].children[1].style.display = "none";
        setSelectedItms([...selectedItms, blankdiv]);
    }

    useEffect(() => {

        if (strike == 10) {
            setShow({ ...show, ["firstshow"]: true });
            markRoundCompleted(nextRound);
        } else if (strike == 20) {
            setShow({ ...show, ["secondshow"]: true });
            markRoundCompleted(nextRound);
        } else if (strike == 30) {
            setShow({ ...show, ["thirdshow"]: true });
            markRoundCompleted(nextRound);
        }

    }, [strike])

    let imgArray = [img0, img1, img2, img3, img4, img5, img6, img7, img8, img9];


    function onAnimationStartCapture(e, index) {

        if (isAnimating == true) {
            console.log('inside', e, index);
            var ids = localvar;

            ids.push(setTimeout(() => {
                console.log('setTimeout Inside :', index)
                GetNextChar(randomSourceArray.current);
            }, 1500));
            setLocalvar(ids);
        }
    }

    let scoretemp = roundScore.toString().split('');

    return (
        <div className='bg-set'>
            <div className="header-part">
                <div className="score-btn" onClick={scoreopenmodal}>
                    <button className="btn" type="button" draggable={false}>
                        <span draggable={false} className='scoreimgs'>
                            {scoretemp.map((val, index) => <img src={imgArray[val]} draggable={false} key={index} />)}
                        </span>
                    </button>
                </div>
                <div className="score-btn strike-btn">
                    <button className="btn" type="button" draggable={false}>
                        <span draggable={false} className='strikes-img'>
                            <img src={imgArray[strike % 10]} draggable={false} />
                            <img src={slashimg} draggable={false} />
                            <img src={img1} draggable={false} />
                            <img src={img0} draggable={false} />
                        </span>
                    </button>
                </div>
                <div className="setting">
                    <button className="btn" type="button" onClick={() => setQuit(true)}><img src={quiticon} alt="" /></button>
                </div>
            </div>

            <Header strike={strike} round={newround} invalidmsg={invalidmsg} />

            {(tournamentId) ? <div className="gameid">
                Tournament Id  : {tournamentId}
            </div> : ""}


            <div className='latterflow'
                ref={removeFromTeamRef}
            >
                {canAnimateAlphabets() && alphabets.map((item, index) => {
                    let flowheight = document.querySelector(".latterflow")?.offsetHeight;
                    let flowheadheight = document.querySelector(".header-part")?.offsetHeight;
                    let flowtimeheight = document.querySelector(".timerbox")?.offsetHeight;
                    let flowtotalheight = flowheight + flowheadheight + flowtimeheight;
                    item.index = index;

                    return (
                        <motion.div
                            animate={{
                                y: flowtotalheight + 40,
                                rotate: [-30, 0, 30, 0]
                            }}
                            transition={{
                                duration: 15,
                                ease: "linear",
                                delay: index == 0 ? 0 : index * 1.5
                            }}
                            className='latterflow_item'
                            onAnimationComplete={(e) => onAnimationComplete(e, index)}
                            onAnimationStart={(e) => onAnimationStartCapture(e, index)}
                            key={index}
                            index={index}
                            style={item.image && opc}
                        >
                            <DragLatter
                                item={item}
                                alphabetType="alphabet"
                                onDropAlphabet={moveFirstAlphabetToContainer}
                                index={index}
                                key={index}
                                callback={setStrickDataValue}

                            />
                        </motion.div>
                    )
                })}
            </div>

            <div className='inputboxes'>
                <div
                    className={reset == false ? "inputbox" : "inputbox animateshakeX"}
                >
                    {containers.map(({ ref, isAlphabetOver, container }, index) => (
                        <div className='remove-letter' key={index}>
                            <div
                                className="dropbox"
                                ref={ref}
                                style={{ background: isAlphabetOver ? '#1114a8' : '#B4E8FF' }}
                                onClick={(e) => shufflevalue(e, index)}
                            >
                                {container ? (
                                    <DragLatter
                                        item={container}
                                        alphabetType="alphabet"
                                        index={index.toString()}
                                        key={index.toString()}
                                        callback={setStrickDataValue}
                                    />
                                ) : null}
                            </div>
                            <button className='remove-btn' onClick={(e) => handleRemove(e, index, container)}><img src={removeletter} /></button>
                        </div>

                    ))}
                </div>


                <div className='lock-btn'>
                    <button className='btn' type='button' onClick={handleSubmit}>Lock It</button>
                </div>
                <ToastContainer autoClose={2000} />
            </div>
            <ScoreChart show={scoremodal} close={scoreclosemodal} />
            <GameHistoryModal show={historyModal} close={historycloseModal} />

            {/* round 1 modal start here */}
            <div className='roundsecond final-btn'>
                <div className={`modal ${show.firstshow ? 'show' : ''}`}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className='round-bg'>
                            <div className="modal-header">
                                <h4 className="modal-title"><span>Round 1</span> Completed!</h4>
                            </div>
                            <div className="modal-body">
                                <div className='score-text'>
                                    <h3>Round 1 Score : <span>{allRoundTotalScore[0].score}</span></h3>
                                </div>
                                <div className='roundtotal-score'>
                                    <h3>Total Score : <span>{allRoundTotalScore[0].totalScore}</span></h3>
                                </div>
                                {invalidmsg === 3 ? <div className='reached-limit'>
                                    <p>**Reached 3 invalid word limit</p>
                                </div> : ""}

                            </div>
                            <div className="modal-footer">
                                <button onClick={jumptoNextround}>Continue to Round 2</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* round 1 modal end here */}

            {/* round 2 modal start here */}
            <div className='roundsecond final-btn'>
                <div className={`modal ${show.secondshow ? 'show' : ''}`}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className='round-bg'>
                            <div className="modal-header">
                                <h4 className="modal-title"><span>Round 2</span> Completed!</h4>
                            </div>
                            <div className="modal-body">
                                <div className='score-text'>
                                    <h3>Round 1 Score : <span>{allRoundTotalScore[0].score}</span></h3>
                                </div>
                                <div className='score-text'>
                                    <h3>Round 2 Score : <span>{allRoundTotalScore[1].score}</span></h3>
                                </div>
                                <div className='roundtotal-score'>
                                    <h3>Total Score : <span>{allRoundTotalScore[1].totalScore}</span></h3>
                                </div>
                                {invalidmsg === 3 ? <div className='reached-limit'>
                                    <p>**Reached 3 invalid word limit</p>
                                </div> : ""}
                            </div>
                            <div className="modal-footer">
                                <button onClick={jumptoNextround}>Continue to Round 3</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* round 2 modal end here */}

            {/* round 3 modal start here */}
            <div className='roundsecond'>
                <div className={`modal ${show.thirdshow ? 'show' : ''}`}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className='round-bg'>
                            <div className="modal-header">
                                <h4 className="modal-title"><span>Round 3</span> Completed!</h4>
                            </div>
                            <div className="modal-body">
                                <div className='score-text'>
                                    <h3>Round 1 Score : <span>{allRoundTotalScore[0].score}</span></h3>
                                </div>
                                <div className='score-text'>
                                    <h3>Round 2 Score : <span>{allRoundTotalScore[1].score}</span></h3>
                                </div>
                                <div className='score-text'>
                                    <h3>Round 3 Score : <span>{allRoundTotalScore[2].score}</span></h3>
                                </div>
                                <div className='roundtotal-score'>
                                    <h3>Total Score : <span>{allRoundTotalScore[2].totalScore}</span></h3>
                                </div>
                                {invalidmsg === 3 ? <div className='reached-limit'>
                                    <p>**Reached 3 invalid word limit</p>
                                </div> : ""}
                            </div>
                            <div className="modal-footer">
                                <button onClick={backtoHome}>Back to Home</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            {/* round 3 modal end here */}

            {/* multiple login error msg modal start*/}

            <div className='roundsecond final-btn error-msgg'>
                <div className={`modal ${show.errormsg ? 'show' : ''}`}>
                    <div className="modal-content" onClick={e => e.stopPropagation()}>
                        <div className='round-bg'>
                            <div className="modal-body">
                                <div className='score-text'>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-exclamation-circle" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#000000" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                        <path d="M12 9v4" />
                                        <path d="M12 16v.01" />
                                    </svg>
                                    <h3>{errormsg}</h3>
                                </div>
                            </div>
                            <div className="modal-footer">
                                <button onClick={backtoHome}>Okay</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* multiple login error msg modal end */}

            {quit ?
                <div className='roundsecond final-btn logout_modal'>
                    <div className={`modal ${setQuit ? 'show' : ''}`} >
                        <div className="modal-content" onClick={e => e.stopPropagation()}>
                            <div className='round-bg'>
                                <div className="modal-body">
                                    <div className='score-text'>
                                        <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-exclamation-circle" width="24" height="24" viewBox="0 0 24 24" strokeWidth="1.5" stroke="#000000" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
                                            <path d="M12 9v4" />
                                            <path d="M12 16v.01" />
                                        </svg>
                                        <h3>Are you sure want to Quit the game !</h3>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button onClick={() => setQuit(false)}>Continue</button>
                                    <button onClick={backtoHome}>Quit</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                : ""}

        </div >

    )
}

export default LetterText
